<template>
  <div>
    <main-navigation/>
    <router-view/>
    <div id="notifications" class="p-2 fixed-bottom">
      <b-alert
        v-for="(notification, index) in notifications"
        :key="index"
        :show="notification.countDown === undefined ? true : notification.countDown"
        class="w-50 mx-auto"
        @dismissed="dismissNotification(notification)"
        :variant="notification.variant || 'info'">
        <!-- there is magic happening with count down (see source of alert component for details) -->
        <button type="button" aria-label="Close" class="close" @click="dismissNotification(notification)">×</button>
        <div v-html="notification.message"></div>
      </b-alert>
    </div>
    <v-tour
      name="tour"
      :steps="currentTour"
      :callbacks="helpTourCallbacks"
      :options="helpTourOptions">

      <template #default="tour">
        <transition name="fade" v-for="(step, index) of tour.steps" :key="index">
          <v-step
            v-if="tour.currentStep === index"
            :step="step"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :isFirst="tour.isFirst"
            :isLast="tour.isLast"
          >
            <div slot="actions" class="v-step__buttons">
              <button @click.prevent="onSkipTour" class="v-step__button">Skip tour</button>
              <button @click.prevent="tour.previousStep" v-if="!tour.isFirst" class="v-step__button">Previous</button>
              <button @click.prevent="tour.nextStep" v-if="!tour.isLast" class="v-step__button">Next</button>
              <button @click.prevent="tour.stop" v-if="tour.isLast" class="v-step__button">OK</button>
            </div>
          </v-step>
        </transition>
      </template>
    </v-tour>
    <v-tour name="help-tour" :steps="helpTour" :options="helpTourOptions"/>
  </div>
</template>

<script>
  import MainNavigation from './components/MainNavigation.vue';
  import {mapActions, mapMutations, mapState} from 'vuex';
  import {DISMISS_NOTIFICATION} from './store/mutation-types';
  import tours, {HELP_TOUR_TIMEOUT, helpTourOptions} from './components/Tour/tours';

  export default {
    name: 'app',
    components: {MainNavigation},
    data() {
      return {
        ...tours,
        timer: null,
        helpTourOptions,
        helpTourCallbacks: {onStart: this.onStartTour, onStop: this.onStopTour},
      };
    },
    computed: {
      ...mapState({
        skipTour: state => state.auth.config && state.auth.config.skipTour,
        notifications: state => state.notifications,
        currentWorkspace(state) {
          return this.$route.params.id === undefined ? undefined : state.workspaces.find(w => w.id === parseInt(this.$route.params.id, 10));
        },
        workspacesFilterExpanded: state => state.ui.workspacesFilterExpanded,
        useDarkTheme: state => state.ui.useDarkTheme,
      }),
      currentTour() {
        if (!this.skipTour) {
          if (this.$route.name === 'workspace' && this.currentWorkspace && this.currentWorkspace.panels.length > 0) {
            const panel = this.currentWorkspace.panels[0];
            switch (panel.options.showAs) {
              case 'text':
                return this.textPanelTour;
              default:
                if (panel.options.isEditing) {
                  if (panel.selection.runs.length === 0) {
                    return this.basicFiltersTour;
                  } else {
                    return this.extraFiltersTour(this.$config);
                  }
                } else {
                  return this.expandPanelsTour;
                }
            }
          } else if (this.$route.name === 'workspace' && this.currentWorkspace && this.currentWorkspace.panels.length === 0) {
            return this.panelManagementTour;
          } else if (this.$route.name === 'workspaces') {
            if (this.workspacesFilterExpanded) {
              return this.workspaceManagementTour;
            } else {
              return this.expandPanelsTour;
            }
          }
        }
        return [];
      },
    },
    methods: {
      ...mapMutations({dismissNotification: DISMISS_NOTIFICATION}),
      ...mapActions(['fetchUserDetails', 'toggleTour']),
      onStartTour() {
        if (this.skipTour && this.currentTour !== this.helpTour) {
          this.$tours['tour'].currentStep = -2;
        } else if (this.currentTour === this.helpTour) {

        }
      },
      onSkipTour() {
        this.$tours['tour'].stop();
        this.toggleTour({skip: true, auth: this.$auth});
        this.triggerHelpTour();
      },
      onStopTour() {
        // this.triggerHelpTour();
      },
      triggerHelpTour() {
        this.$tours['help-tour'].start();
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.$tours['help-tour'].stop(), HELP_TOUR_TIMEOUT);
      },
    },
    watch: {
      currentTour(currentTour) {
        this.$tours.tour && this.$tours.tour.stop();
        if (currentTour && currentTour.length > 0) {
          this.$tours.tour && this.$tours.tour.start();
        }
      },
      useDarkTheme: {
        handler(useDarkTheme) {
          document.body.parentNode.classList.toggle('dark-theme', useDarkTheme);
        },
        immediate: true,
      },
    },
    created() {
      document.title = this.$config.productName;
      // check if auth token is valid for non-public routes
      if (this.$auth.isLoggedIn) this.fetchUserDetails({silent: true});
    },
    beforeDestroy() {
      clearTimeout(this.timer);
    },
  };
</script>

<style lang="scss">

  body {
    margin: 0
  }

  // you can customize bootstrap theme here
  $enable-rounded: false !default;

  $iiasa: #00589d !default;

  $theme-colors: (
    "iiasa": $iiasa,
  );

  html.dark-theme {
    @import "./darktheme.scss";
    @import "~bootstrap";
    @import '~bootstrap-vue';
    @import "./custom.scss";
  }

  html:not(.dark-theme) {
    @import "~bootstrap";
    @import '~bootstrap-vue';
    @import "./custom.scss";
  }

</style>
<style scoped>
  #notifications {
    z-index: 1055;
  }
</style>
